import React from 'react';
import { Box, Button, ButtonBase, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ChevronRightRounded as ChevronIcon } from '@mui/icons-material';
import colors from '../../assets/theme/colors';

const PreparationEvidenceReview = ({ items = [], canEdit, accent, decidingSourceId, onOpen, onDecide }) => {
  if (!items.length) return null;
  return (
    <Stack spacing={0.8} sx={{ p: 1.1, borderRadius: '14px', bgcolor: alpha('#B7791F', 0.06), border: `1px solid ${alpha('#B7791F', 0.18)}` }}>
      <Typography sx={{ fontSize: '0.76rem', fontWeight: 750, color: '#8A5A16' }}>Needs a quick check</Typography>
      {items.map((item) => {
        const sourceId = `${item.sourceType}:${item.sourceId}`;
        const deciding = decidingSourceId === sourceId;
        return (
          <Box key={sourceId} sx={{ pb: 0.8, '&:not(:last-child)': { borderBottom: `1px solid ${alpha(colors.semantic.ink, 0.08)}` } }}>
            <ButtonBase onClick={() => onOpen(item)} sx={{ width: '100%', justifyContent: 'flex-start', textAlign: 'left', gap: 0.6, borderRadius: '10px', py: 0.35 }}>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography sx={{ fontSize: '0.86rem', lineHeight: 1.4, color: colors.semantic.ink }}>{item.description || item.label}</Typography>
                {item.relevanceReason ? <Typography sx={{ mt: 0.2, fontSize: '0.75rem', lineHeight: 1.35, color: alpha(colors.semantic.ink, 0.58) }}>{item.relevanceReason}</Typography> : null}
              </Box>
              <ChevronIcon sx={{ color: accent.ink, flexShrink: 0 }} />
            </ButtonBase>
            {canEdit ? (
              <Stack direction="row" spacing={0.7} sx={{ mt: 0.55 }}>
                <Button size="small" disabled={deciding} onClick={() => onDecide(item, 'accepted')} sx={{ minWidth: 0, textTransform: 'none', fontWeight: 700 }}>Use in preparation</Button>
                <Button size="small" disabled={deciding} onClick={() => onDecide(item, 'dismissed')} sx={{ minWidth: 0, textTransform: 'none', color: alpha(colors.semantic.ink, 0.62) }}>Leave out</Button>
              </Stack>
            ) : null}
          </Box>
        );
      })}
    </Stack>
  );
};

export default PreparationEvidenceReview;
